import React from 'react'
import { Box, Button, IconButton, Paper, Stack, Tooltip, Typography } from '@mui/material'
import InstagramIcon from '@mui/icons-material/Instagram'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'

const TikTokIcon = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.53 2h3.45a8.16 8.16 0 0 0 4.77 1.52v3.4a4.85 4.85 0 0 1-4.77-4.25v13.04a6.34 6.34 0 1 1-6.34-6.34c.32 0 .63.03.94.08V13a2.89 2.89 0 1 0 1.95 2.74V2z" />
  </svg>
)

const socialLinks = [
  {
    icon: InstagramIcon,
    label: 'Instagram',
    url: 'https://www.instagram.com/nexocartperfumes?igsh=NzhqaHhjcDFkNXZn',
    color: '#E4405F',
  },
  {
    icon: TikTokIcon,
    label: 'TikTok',
    url: 'https://www.tiktok.com/@nexocart.perfumes?_r=1&_t=ZS-96jK4KKQYde',
    color: '#111111',
  },
  {
    icon: WhatsAppIcon,
    label: 'WhatsApp',
    url: 'https://whatsapp.com/channel/0029VbCWGUrFCCoMptsNfm26',
    color: '#25D366',
  },
]

export const SocialFollowBanner = () => (
  <Box component="section" sx={{ px: { xs: 2, md: 5 }, py: { xs: 4, md: 5 }, bgcolor: '#fff' }}>
    <Paper
      elevation={0}
      sx={{
        maxWidth: 1180,
        mx: 'auto',
        p: { xs: 2.5, md: 4 },
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        bgcolor: '#0f0f0f',
        color: '#fff',
      }}
    >
      <Stack direction={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'flex-start', md: 'center' }} justifyContent="space-between" gap={3}>
        <Stack rowGap={0.5}>
          <Typography variant="h4" sx={{ fontSize: { xs: '1.7rem', md: '2.25rem' }, fontWeight: 900 }}>
            Follow the fragrance drop before it sells out
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,.72)', maxWidth: 680 }}>
            Join Nexocart Perfumes on social media for new launch videos, real customer feedback, tester updates, and limited-time offers.
          </Typography>
        </Stack>

        <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
          {socialLinks.map((social) => {
            const Icon = social.icon
            return (
              <Tooltip key={social.label} title={social.label}>
                <IconButton
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    width: 46,
                    height: 46,
                    bgcolor: '#fff',
                    color: social.color,
                    '&:hover': {
                      bgcolor: '#fff',
                      transform: 'translateY(-3px)',
                    },
                  }}
                >
                  <Icon />
                </IconButton>
              </Tooltip>
            )
          })}
          <Button
            variant="outlined"
            href={socialLinks[0].url}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ color: '#fff', borderColor: 'rgba(255,255,255,.5)', ml: { xs: 0, sm: 1 } }}
          >
            Follow Us
          </Button>
        </Stack>
      </Stack>
    </Paper>
  </Box>
)
